'use client';

import { useEffect } from 'react';
import { useNativeFeatures } from '@/hooks/useNativeFeatures';
import { PerformanceMonitor } from '@/lib/performance-monitor';
import { SimpleVersionChecker } from './SimpleVersionChecker';

interface NativeProviderProps {
  children: React.ReactNode;
}

/**
 * 原生化特性提供者
 * 初始化所有原生化功能和性能监控
 */
export function NativeProvider({ children }: NativeProviderProps) {
  const nativeFeatures = useNativeFeatures();
  
  useEffect(() => {
    // 初始化性能监控
    PerformanceMonitor.init();
    
    // 注册 Service Worker
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      navigator.serviceWorker.register('/sw.js').then(
        (registration) => {
          console.log('Service Worker 注册成功:', registration.scope);
        },
        (error) => {
          console.error('Service Worker 注册失败:', error);
        }
      );
    }
    
    // 检查是否在 PWA 模式下运行
    if (nativeFeatures.isStandalone()) {
      document.body.classList.add('pwa-mode');
    }
  }, [nativeFeatures]);
  
  return (
    <>
      {children}
      <SimpleVersionChecker />
    </>
  );
}